import { HOME_USERS } from '@/utils/constants/routes'

export default (ctx) => {
  const userId = ctx.route.params.userId
  return ctx.redirect(`${HOME_USERS}/${userId}/declarations`)
}
